import { Img, Spinner } from "components";
import Stepper from "components/Stepper/newstepper";
import { useState } from "react";
import { formatIndianNumber, refundOrderSteps } from "utils";
import Step1 from "./step1";
import Step2 from "./step2";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { AxiosRequestConfig } from "axios";
import { Skeleton } from "@/components/ui/skeleton";
import { useDebounce } from "pages/CreateDeal/newdeal";
import {
  postRefundOrder,
  postRefundOrderRequestType,
} from "service/apis/RefundOrder";
import {
  resetRefundOrder,
  setRefundId as setRefundID,
} from "redux/features/RefundOrder";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function Index() {
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const {
    purpose_id,
    currency,
    reason,
    otherReason,
    sender_name,
    refundable_amount,
    AD_ref_no,
    bank_document,
    amount_sent,
    my_margin,
    order_id,
    partner_margin,
    settlement_rate,
    partner_order_id,
  } = useAppSelector((state) => state.CreateRefundOrder);
  const [calTotalPayable, setCalTotalPayable] = useState("");
  const [customerRate, setCustomerRate] = useState("");
  const [receipientGets, setRecipientGets] = useState("");
  const [refundId, setRefundId] = useState("");
  const [refundAmout, setRefundAmount] = useState("");
  const dispatch = useAppDispatch();
  const navigate = useNavigate()
  // set the state to the previous page
  const finalReason = reason === "other" ? otherReason : reason;

  const handleNext = () => {
    if (currentStep < refundOrderSteps.length) {
      setCurrentStep(currentStep + 1);
    } else {
      handleProcessRefund();
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const buttonState = () => {
    switch (currentStep) {
      case 1:
        if (!finalReason || !AD_ref_no || !purpose_id || !sender_name) return true;
        return false;
      case 2:
        if (
          !settlement_rate ||
          !my_margin ||
          (Number(partner_order_id) ? !partner_margin : false) ||
          !refundable_amount
        )
          return true;
        return false;
      default:
        return false;
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <Step1 />;
      case 2:
        return <Step2 />;
      default:
        return <Step1 />;
    }
  };
  //     setLoading(true);
  //     setIsCalcLoading(true);
  //     const auth = localStorage.getItem("authToken");
  //     if (auth === null) return null;
  //     const authToken = JSON.parse(auth);

  //     const payload: AxiosRequestConfig<PostOrderCalcRequestType> = {
  //         headers: { Authorization: `Bearer ${authToken}` },
  //         data: {
  //             purpose_id: parseInt(purpose_id),
  //             currency: currency === "" ? "USD" : currency,
  //             amount: parseInt(amount_sent),
  //             type: 'beneficiary_receives',
  //             created_by: parseInt(created_by),
  //             tcs_type: 1,
  //             discount: 0,
  //             add_on_rates: 0,
  //             settlement_rates: settlement_rate,
  //             service_partner_id: service_partner_id,
  //             tt_charges: tt_rate,
  //             foreign_bank_charges: foreign_bank_rate,
  //             deal_id: deal_id,
  //             l1_commission: my_margin,
  //             l2_commission: partner_margin,
  //             l3_commission: 0
  //         },
  //     };

  //     if (currency && purpose_id && amount_sent) {
  //         postOrderCalc(payload)
  //             .then((res) => {
  //                 const refund_amount = parseFloat(res.data.base_amount) / parseFloat(res.data.customer_rate)
  //                 setCalcTotalCharges(
  //                     parseFloat(res.data.payable_amount) -
  //                     parseFloat(res.data.base_amount),
  //                 );
  //                 if (level === "1") {
  //                     (setCalProfit(res.data.profit.l1));
  //                 }
  //                 else if (level === "2") {
  //                     (setCalProfit(res.data.profit.l2));
  //                 }
  //                 else if (level === "3") {
  //                     (setCalProfit(res.data.profit.l3));
  //                 }
  //                 setCalAmountInr(res.data.base_amount)
  //                 setCalGst(res.data.gst)
  //                 setCalTTCharges(res.data.tt_charges_with_gst)
  //                 setCalTotalPayable(res.data.payable_amount)
  //                 dispatch(setRefundableAmount(refund_amount.toString()));
  //                 setTcs(res.data.tcs)
  //                 setCalForeignBankCharges(res.data.foreign_bank_charges_with_gst);
  //                 setCalYourRate(
  //                     (
  //                         parseFloat(res?.data?.settlement_rates) +
  //                         (level === "2" ? res?.data?.cumulative_commission.l1 : 0) +
  //                         (level === "3" ? res?.data?.cumulative_commission.l2 : 0)
  //                     )?.toFixed(4),
  //                 );

  //                 setRate(
  //                     parseFloat(res?.data?.settlement_rates) +
  //                     (res?.data?.cumulative_commission_without_addon.l3 > 0
  //                         ? res?.data?.cumulative_commission_without_addon.l3
  //                         : res?.data?.cumulative_commission_without_addon.l2 > 0
  //                             ? res?.data?.cumulative_commission_without_addon.l2
  //                             : res?.data?.cumulative_commission_without_addon.l1),
  //                 );
  //                 setCustomerRate(Number(res.data.customer_rate)?.toFixed(4));
  //                 setCalCustomerRate(
  //                     parseFloat(res.data.customer_rate)?.toFixed(4)?.toString(),
  //                 );
  //                 setLoading(false);
  //                 setIsCalcLoading(false);
  //             })
  //             .catch((err) => {
  //                 setLoading(false);
  //                 setIsCalcLoading(false);
  //             });
  //     }
  // };

  const handleRateCalculation = () => {
    const settlementRate = parseFloat(settlement_rate);
    let aggMargin;
    if (Number(partner_order_id)) {
      aggMargin = parseFloat(my_margin) + parseFloat(partner_margin);
    } else {
      aggMargin = parseFloat(my_margin);
    }
    const customerRate = settlementRate - aggMargin;
    if (customerRate < 0) {
      toast.error("Customer rate can not be negative");
      return;
    }
    setCustomerRate(customerRate.toFixed(4));
    setRecipientGets(refundable_amount);
    const totalPayable = parseFloat(refundable_amount) * customerRate;
    setCalTotalPayable(totalPayable.toFixed(2));
  };

  const handleProcessRefund = async () => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    const newDocs = bank_document.map((doc) => {
      return {
        doc_list_id: doc.id as string,
        file: doc.file as string,
      };
    });

    const payload: AxiosRequestConfig<postRefundOrderRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        order_id: order_id,
        reason: finalReason,
        fx_amount: refundable_amount,
        settlement_rate: settlement_rate,
        my_margin: my_margin,
        partner_margin: partner_margin,
        document: newDocs,
        ad_ref_no: AD_ref_no,
        inr_amount: calTotalPayable,
        customer_rate: customerRate,
      },
    };
    try {
      const response: any = await postRefundOrder(payload);
      if (response.status === 200) {
        setLoading(false);
        toast.success("Refund Order Created Successfully");
        setRefundId(response?.data?.id);
        dispatch(setRefundID(response?.data?.id as string));
        setRefundAmount(response?.data?.amount_inr);
        dispatch(resetRefundOrder());
        setCurrentStep(3);
        setTimeout(() => {
          navigate('/remit/orders', { replace: true })
        }, 3000);
      }
    } catch (error) {
      setLoading(false);
      toast.error("Refund Order Creation Failed");
    }
  };
  useDebounce(
    () => {
      if (currency && purpose_id && amount_sent) {
        handleRateCalculation();
      }
    },
    1000,
    [my_margin, partner_margin, settlement_rate, refundable_amount],
  );
  return (
    <>
      {loading && <Spinner />}
      <div className="sm:p-1 flex font-inter items-start justify-between gap-5 overflow-hidden mx-auto w-full h-full">
        {currentStep === 3 ? (
          <div className="gap-5 bg-white-A700 w-full flex h-full flex-col p-3 rounded-lg">
            <div className=" flex flex-col py-5 px-8 w-1/2 gap-5 border border-white-A700 rounded-xl shadow-deal-success">
              <div className="flex justify-between w-full">
                <div className="flex flex-col gap-5">
                  <div className="flex flex-col gap-2">
                    <h3 className="text-lg leading-4 font-semibold text-blue-700">
                      Refund order created successfully
                    </h3>
                  </div>
                  <span className="border border-blue-700 bg-[#F3F8FF] rounded-lg py-2 px-4">
                    Refund ID <span className="text-blue-700">RID</span>-
                    {refundId}
                  </span>
                </div>
                <div className="flex flex-col justify-between">
                  <Img src="/images/overview/success.svg" />
                  <p className="text-green-parrot">Success</p>
                </div>
              </div>
              <div className=" text-white-A700 bg-black-label rounded-lg py-2 px-3 items-center justify-between flex gap-2.5">
                <div className=" text-base leading-5 font-normal">
                  <p>Amount</p>
                </div>
                <div className="flex gap-2">
                  <span className="px-2 border rounded-lg border-white-A700">
                    INR
                  </span>
                  <p>{parseFloat(refundAmout).toFixed(2)}</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <section className="gap-5 bg-white-A700 w-full flex h-full flex-col p-3 rounded-lg">
              <div className="flex flex-col justify-between h-full gap-5 w-full sm:px-0 overflow-auto">
                <Stepper
                  steps={refundOrderSteps.map((val) => val.name)}
                  currentStep={currentStep - 1}
                />
                <div className="flex relative flex-col gap-5 w-full overflow-y-auto flex-grow">
                  {renderStep()}
                </div>
                <div className="flex gap-3 sm:flex-col sm:items-start">
                  {currentStep !== 1 && (
                    <button
                      onClick={handlePrevious}
                      className="px-4 py-[11px] w-fit text-sm font-semibold rounded-lg text-blue-700 border border-blue-700"
                    >
                      Previous
                    </button>
                  )}
                  {
                    <button
                      disabled={buttonState()}
                      onClick={handleNext}
                      className="px-4 py-[11px] w-fit disabled:opacity-40 text-sm font-semibold rounded-lg text-white-A700 border border-blue-700 bg-blue-700 "
                    >
                      {currentStep !== refundOrderSteps.length - 1
                        ? "Submit"
                        : "Next"}
                    </button>
                  }
                </div>
              </div>
            </section>
            {currentStep === 2 && (
              <section className=" bg-white-A700 h-full rounded-lg w-1/3 p-3">
                <p className="text-lg leading-4 font-semibold">Calculations</p>
                <div className="pt-5 pb-10 px-5 border-b-8 flex flex-col rounded-xl bg-custom-calc-gradient border-blue-700 gap-10">
                  <div className="divide-y divide-neutral-400_1 gap-5 flex flex-col">
                    <div className="flex flex-col gap-4 w-full">
                      <div className="flex justify-between w-full">
                        <span className="text-xs leading-[14.5px] indent-3.5 text-[#666666]">
                          Customer Rate
                        </span>
                        {loading ? (
                          <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                        ) : (
                          <span className="text-sm text-gray-900 float-right leading-4 flex items-center space-x-[2px] gap-1">
                            {isNaN(Number(customerRate)) ? (
                              "0.00"
                            ) : (
                              <>
                                <span className="flex items-center bg-[#F5F5F5] border border-black-300 rounded-full px-2 py-0.5">
                                  INR
                                </span>
                                { }
                                {parseFloat(customerRate)?.toFixed(4)}
                              </>
                            )}
                          </span>
                        )}
                      </div>
                      <div className="flex justify-between w-full">
                        <span className="text-xs leading-[14.5px] indent-3.5 text-[#666666]">
                          Recipient gets
                        </span>
                        {loading ? (
                          <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                        ) : (
                          <span className="text-sm text-gray-900 float-right leading-4 flex items-center space-x-[2px] gap-1">
                            {receipientGets === "" || amount_sent === "" ? (
                              "0.00"
                            ) : (
                              <>
                                <span className="flex items-center bg-[#F5F5F5] border border-black-300 rounded-full px-2 py-0.5">
                                  {currency === "" || currency === undefined
                                    ? "USD "
                                    : `${currency} `}
                                </span>{" "}
                                {formatIndianNumber(
                                  parseFloat(receipientGets)?.toFixed(4),
                                ).toString()}
                              </>
                            )}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex justify-between pt-2.5 text-blue-700 w-full">
                      <span className="text-xs leading-[14.5px] indent-3.5 font-semibold">
                        Total estimation
                      </span>
                      {loading ? (
                        <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                      ) : (
                        <span className="text-xs font-semibold float-right leading-4 indent-3.5 text-blue-700">
                          {isNaN(Number(calTotalPayable)) ? (
                            "0.00"
                          ) : (
                            <>
                              <span className="bg-[#E8F0FF] indent-3.5 border border-blue-300 rounded-full px-2 py-0.5">
                                INR
                              </span>{" "}
                              {formatIndianNumber(
                                parseFloat(calTotalPayable)?.toFixed(2),
                              )}
                            </>
                          )}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className=" flex-1 h-full flex justify-end items-end ">
                  <div className="flex flex-col gap-3 p-2">
                    <p className="font-normal leading-[19.2px] text-xs text-[#666666]">
                      The above amount is an estimate and may change based on
                      real time fx rates and remitter's current FY transactions.
                    </p>
                    <h4 className="font-medium leading-[19.2px] text-xs text-[##232323]">
                      Decimal are rounded off.
                    </h4>
                  </div>
                </div>
              </section>
            )}
          </>
        )}
      </div>
    </>
  );
}
